import { USER_INFO_NAME } from "./config";

export default userInfo => {
  localStorage.setItem(USER_INFO_NAME, JSON.stringify(userInfo));
};
